export type TourStep = {
  route: string;
  selector: string;
  title: string;
  description: string;
};

export const TOUR_STEPS: TourStep[] = [
  {
    route: "/dashboard",
    selector: '[data-tour="dashboard-overview"]',
    title: "Your home base",
    description:
      "The dashboard summarizes new messages, teaming activity, and reminders so you can pick up where you left off.",
  },
  {
    route: "/dashboard",
    selector: '[data-tour="dashboard-stats"]',
    title: "Workspace at a glance",
    description:
      "These cards show how many vendors are on SPN, your teaming posts, conversations, and pending AI extractions awaiting review.",
  },
  {
    route: "/vendor-profile",
    selector: '[data-tour="vendor-profile-form"]',
    title: "Build your vendor profile",
    description:
      "Tell partners who you are: capabilities, certifications, NAICS, and contact info. A complete profile is how partners find you.",
  },
  {
    route: "/vendor-profile",
    selector: '[data-tour="vendor-profile-save"]',
    title: "Save & publish",
    description:
      "Click Save to publish your profile to the network. You can come back and update it any time.",
  },
  {
    route: "/agency-experience",
    selector: '[data-tour="agency-experience-list"]',
    title: "Record agency experience",
    description:
      "Log past-performance records — agency, contract, and role. Each record has a visibility level (public, limited, or private) so you control what partners see.",
  },
  {
    route: "/documents",
    selector: '[data-tour="documents-upload"]',
    title: "Upload capability docs",
    description:
      "Upload your capability statement or paste text. Run AI to auto-extract a draft profile and agency experience for review.",
  },
  {
    route: "/documents",
    selector: '[data-tour="documents-run-ai"]',
    title: "Run AI extraction",
    description:
      "Each document has a Run AI button that drafts profile fields. Drafts queue up in the review panel below.",
  },
  {
    route: "/discover",
    selector: '[data-tour="discover-search"]',
    title: "Discover vendors on SAM.gov",
    description:
      "Look up any registered government contractor by name, UEI, or NAICS — even if they aren't on SPN yet.",
  },
  {
    route: "/search",
    selector: '[data-tour="search-filters"]',
    title: "Search vendors on SPN",
    description:
      "Filter by capability, certification, NAICS, PSC, contract vehicle, and agency. Filters combine with the search box.",
  },
  {
    route: "/search",
    selector: '[data-tour="search-scope-toggle"]',
    title: "On / Off / All",
    description:
      "Toggle between SPN-only results, off-SPN SAM.gov coverage, or both at once.",
  },
  {
    route: "/watchlist",
    selector: '[data-tour="watchlist-list"]',
    title: "Track off-SPN vendors",
    description:
      "Save vendors you want to team with. We'll auto-update each row when they accept an invite or join SPN.",
  },
  {
    route: "/opportunities",
    selector: '[data-tour="opportunities-list"]',
    title: "Matched opportunities",
    description:
      "SAM.gov opportunities scored against your profile — each match gets a fit score and a recommendation badge so you know which bids are worth pursuing.",
  },
  {
    route: "/partners",
    selector: '[data-tour="partners-roster"]',
    title: "Your partner roster",
    description:
      "Add SPN vendors you team with. Partners boost combined-team scores, so a bid you'd skip solo can become recommended as a team.",
  },
  {
    route: "/teaming",
    selector: '[data-tour="teaming-feed"]',
    title: "Public teaming posts",
    description:
      "Post a need, or browse posts from other vendors. Everyone signed in can see these.",
  },
  {
    route: "/teaming",
    selector: '[data-tour="teaming-new-post"]',
    title: "Create a teaming post",
    description:
      "Click here to publish a new teaming post — describe the opportunity, due date, and what kind of partner you need.",
  },
  {
    route: "/marketplace",
    selector: '[data-tour="marketplace-home"]',
    title: "Marketplace & forum",
    description:
      "Browse opportunities, the public roadmap, and discussion threads with the broader SPN community.",
  },
  {
    route: "/messages",
    selector: '[data-tour="messages-list"]',
    title: "Direct messages",
    description:
      "1:1 conversations between vendor workspaces. Pinned to the bell icon in the sidebar.",
  },
  {
    route: "/settings/team",
    selector: '[data-tour="team-invite-form"]',
    title: "Invite your coworkers",
    description:
      "Bring teammates into your workspace by email — they'll share your vendor profile, matches, and conversations.",
  },
];
